import type { Property } from "@ext/properties/models";

export interface ArticlePropertyRowData {
	isAssigned: boolean;
	property: Property;
}

export const getArticlePropertyRows = (
	catalogProperties: Property[],
	articleProperties: Property[],
): ArticlePropertyRowData[] => {
	const articlePropertyMap = new Map(articleProperties.map((property) => [property.id, property]));

	return catalogProperties.map((property) => {
		const articleProperty = articlePropertyMap.get(property.id);
		return {
			isAssigned: articlePropertyMap.has(property.id),
			property: { ...property, value: articleProperty?.value },
		};
	});
};
